function mmShowAccordeonContent(elemToShowClass, titleClass) {
    var accordeonToShow = document.querySelector(elemToShowClass);
    var title = document.querySelector(titleClass);

    var accordeonHeight = accordeonToShow.scrollHeight;
    if (accordeonToShow.style.height == "0px" || accordeonToShow.style.height == "") {
        accordeonToShow.style.height = accordeonHeight + "px";
    } else {
        accordeonToShow.style.height = "0px";
    }

    title.classList.toggle("mm-active");
}

function mmQtty(delta) {
    var number = document.querySelector(".mm-product-qtty-number");
    var oldValue = number.value;
    if (oldValue == 1 && delta == -1) {
    } else {
        let newValue = parseInt(oldValue, 10) + parseInt(delta, 10);
        number.value = newValue;
	      mmUpdatePrice(newValue);

    }
}

function mmUpdatePrice(qtty) {
  let priceAll = document.querySelectorAll(".mm-product-price-update");
  priceAll.forEach(function (price) {
    price.innerHTML = `${((price.dataset.value * qtty) / 100).toFixed(2)}€`;
  });
}


function displayForVideo(statut) {
    var header = document.querySelector(".header-wrapper");
    if (statut == "open") {
        document.querySelector("html").classList.add("stop-scrolling");
        header.classList.add("mm-header-fixed-video");
    } else if (statut == "close") {
        document.querySelector("html").classList.remove("stop-scrolling");
        header.classList.remove("mm-header-fixed-video");
        var mmVideo = document.querySelector(".mm-video-popup_video-content");
        var playerVimeo = new Vimeo.Player(mmVideo);
        if (playerVimeo != null) {
          playerVimeo.pause().then(function () {
            return playerVimeo.setCurrentTime(0);
          });
        } else {
          mmVideo.pause();
          mmVideo.currentTime = 0;
        }
    }
}

if (window.innerWidth < 768) {
    (function () {
        function onTidioChatApiReady() {
            window.tidioChatApi.hide();
            window.tidioChatApi.on("close", function () {
                window.tidioChatApi.hide();
                var html = document.querySelector("html");
                var body = document.querySelector("body");
                html.style.overflow = "";
                html.style.margin = "";
                body.style.overflow = "";
                body.style.height = "";
                body.style.width = "";
                body.style.visibility = "";
                body.style.display = "";
                body.style.inset = "";
                body.style.margin = "";
                body.style.opacity = "";
            });
        }

        if (window.tidioChatApi) {
            window.tidioChatApi.on("ready", onTidioChatApiReady);
        } else {
            document.addEventListener("tidioChat-ready", onTidioChatApiReady);
        }

        document.querySelector(".chat-button").addEventListener("click", function () {
            window.tidioChatApi.show();
            window.tidioChatApi.open();
        });
    })();
}

// FORM
class VariantSelector extends HTMLElement {
  constructor() {
    super();
    this.cached = {};
    this.container = this.closest("#product-form");
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.getSelectedOptions();
    this.getSelectedVariant();

    if (this.currentVariant) {
      this.updateURL();
      this.variantFetch();
      this.updateMedia();
    }
  }

  getSelectedOptions() {
    // Cas 1 : sélecteurs classiques (select)
    if (this.querySelector("select.mm-product-form-variant-values")) {
      this.options = Array.from(
        this.querySelectorAll("select.mm-product-form-variant-values"),
        (select) => select.value
      );
    } 
    // Cas 2 : sélecteurs avec radios (nouvelle version)
    else {
      this.options = Array.from(
        this.querySelectorAll(".mm-product-variant-input:checked, input[type='radio'][name^='mm_options_']:checked"),
        (input) => input.value
      );
    }
  }

  getVariantJSON() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('.mm-main-product-json[type="application/json"]').textContent);
    return this.variantData;
  }

  getSelectedVariant() {
    const variants = this.getVariantJSON();

    // Si on a 2 options sélectionnées (ex: Catégorie + Adaptateur)
    if (this.options.length >= 2) {
      const joined = `${this.options[0]} / ${this.options[1]}`;
      this.currentVariant = variants.find(v => v.public_title === joined);
      if (this.currentVariant) return;
    }

    // Sinon on essaie de matcher par tableau d’options (fallback)
    this.currentVariant = variants.find(variant => {
      if (!variant.options) return false;
      return !variant.options
        .map((opt, i) => this.options[i] === opt)
        .includes(false);
    });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}#mm-selector`
    );
  }

  variantFetch() {
    const variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

    if (this.cached[variantUrl]) {
      this.renderVariantInfo(this.cached[variantUrl]);
      return;
    }

    fetch(variantUrl)
      .then((res) => res.text())
      .then((htmlText) => {
        const html = new DOMParser().parseFromString(htmlText, "text/html");
        this.cached[variantUrl] = html;
        this.renderVariantInfo(html);
      })
      .catch((e) => console.error(e));
  }

  renderVariantInfo(html) {
    this.updateElementOuter("#mmSelectedProductId", html);
    this.updateElementOuter(`#price-${this.dataset.section}`, html);
    this.updateElementOuter(".mm-product-form-submit-button", html);
    this.updateMultipleElement(".mm-reload", html);
  }

  updateElement(selector, html) {
    const dest = this.container.querySelector(selector);
    const src = html.querySelector(selector);
    if (src && dest) dest.innerHTML = src.innerHTML;
  }

  updateElementOuter(selector, html) {
    const dest = this.container.querySelector(selector);
    const src = html.querySelector(selector);
    if (src && dest) dest.outerHTML = src.outerHTML;
  }

  updateMultipleElement(selector, html) {
    const dests = this.container.querySelectorAll(selector);
    const srcs = html.querySelectorAll(selector);
    if (srcs.length && dests.length) {
      for (let i = 0; i < srcs.length; i++) {
        if (dests[i] && srcs[i]) dests[i].outerHTML = srcs[i].outerHTML;
      }
    }
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;

    const mediaId = this.currentVariant.featured_media.id;
    document.querySelectorAll("#thumbnail-carousel .splide__slide").forEach((media) => {
      if (media.dataset.id && media.dataset.id == mediaId) {
        media.click();
      }
    });
  }
}

customElements.define("variant-selector", VariantSelector);


// window.addEventListener("load", function () {
//     setTimeout(function () {
//         const comboInclude = document.querySelector(".bold-bundles-product");
//         if (comboInclude != undefined) {
//             const parentDiv = document.getElementById("mm-bundle-product-{{ section.id }}");
//             if (parentDiv != undefined) {
//                 parentDiv.appendChild(comboInclude);
//             }
//         }
//     }, 50);
// });


/* Toggle Quick Upsell (plaque métal) */
const productForm = document.getElementById("product-form");
const quickUpsell = productForm.querySelector('.mm-upsell-product-container');

if (quickUpsell) {
  const priceContainerAll = productForm.querySelectorAll(".mm-quick-upsell-price");
  quickUpsell.addEventListener("click", () => {
    quickUpsell.classList.toggle("mm-upsell-add-to-card");
    priceContainerAll.forEach((priceContainer) => {
      priceContainer.classList.toggle("hidden");
    })
  })
}

// ACCESSORIES
document.addEventListener("DOMContentLoaded", function () {
  mmSetupProductAccessorties();
});
function mmSetupProductAccessorties() {
  const accessoryCheckboxes = document.querySelectorAll(".mm-product-accessories-container input[type='checkbox']");
  const priceDisplayElements = document.querySelectorAll(".mm-cta-price.mm-quick-upsell-price .mm-product-price-update");

  // Prix du produit principal
    //console.log('priceDisplayElements[0]', priceDisplayElements[0])
    const basePrice = parseInt(priceDisplayElements[0].dataset.price); // Exemple: 4995 = 49,95€
    //console.log('priceDisplayElements[0].dataset.price', priceDisplayElements[0].dataset.price)

  function formatPrice(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '€';
  }
};


function updateCTAButtonPrice() {
  // Récupérer le prix de base depuis un des spans visibles
  const visiblePriceElem = document.querySelector('#product-form .mm-product-price-update');
  const visibleComparePriceElem = document.querySelector('#product-form .mm-product-compare-price-update');
  
  //console.log('visiblePriceElem', visiblePriceElem)
  if (!visiblePriceElem) return;
  //console.log('visiblePriceElem', visiblePriceElem)

  const basePrice = parseInt(visiblePriceElem.getAttribute('data-price')) || 0;
  const baseComparePrice = parseInt(visibleComparePriceElem.getAttribute('data-value')) || 0;

  // Calculer la somme des accessoires cochés
  const checkedAccessories = document.querySelectorAll('.mm-accessory-card input[type="checkbox"]:checked');
  let accessoriesTotal = 0;
  let accessoriesTotalCompare = 0;

  checkedAccessories.forEach(input => {
    const card = input.closest('.mm-accessory-card');
    const reducedVisible = card.querySelector('[data-reduced]')?.style.display !== 'none';
    const unchangedPrice = !!card.querySelector('[data-unchanged]');

    if (unchangedPrice) {

      const price = parseInt(input.getAttribute('data-price'));
      
      const compareAtPrice = parseInt(input.getAttribute('data-price'));
  
      accessoriesTotal += price;
      accessoriesTotalCompare += compareAtPrice;

    } else {

      const price = reducedVisible
        ? parseInt(input.getAttribute('data-price-reduced')) || 0
        : parseInt(input.getAttribute('data-price')) || 0;
      
      const compareAtPrice = parseInt(input.getAttribute('data-price'));
  
      accessoriesTotal += price;
      accessoriesTotalCompare += compareAtPrice;
    }
  });

  const total = basePrice + accessoriesTotal;
  const totalCompare = baseComparePrice + accessoriesTotalCompare;
  console.log('baseComparePrice', baseComparePrice)
  console.log('accessoriesTotalCompare', accessoriesTotalCompare)
  //console.log('basePrice', basePrice)
  //console.log('accessoriesTotal', accessoriesTotal)

  // Mettre à jour toutes les .mm-product-price-update du CTA
  const priceUpdateElems = document.querySelectorAll('#product-form .mm-cta-price .mm-product-price-update');
  const comparePriceUpdateElems = document.querySelectorAll('#product-form .mm-cta-price .mm-product-compare-price-update');
  priceUpdateElems.forEach(el => {
    el.setAttribute('data-value', total);
    el.innerHTML = `${(total / 100).toFixed(2).replace('.', ',')}€`;
  });
  comparePriceUpdateElems.forEach(el => {
    //el.setAttribute('data-value', totalCompare);
    el.innerHTML = `${(totalCompare / 100).toFixed(2).replace('.', ',')}€`;
  });
}


function updateProgressBarPreview() {
  const preview_bar = document.querySelector('#mmProgressBarProduct .mm-dc-free-item-progress--inner-preview');
  const progress_bar = document.querySelector('#mmProgressBarProduct .mm-dc-free-item-progress--inner');
  if (!preview_bar || !progress_bar) return;

  const product_value = parseInt(document.querySelector('#mmDataPriceElem')?.dataset.value || 0);
  const cart_value = parseInt(document.querySelector('.mm-dc-cta')?.dataset.totalPrice || 0);

  const checked_options = document.querySelectorAll('.mm-accessory-card input[type="checkbox"]:checked');
  let options_value = 0;
  checked_options.forEach(input => {
    options_value += parseInt(input.dataset.displayedPrice);
  });

  const total_predictive_value = product_value + cart_value;
  //console.log('product_value', product_value)
  //console.log('options_value', options_value)
  //console.log('cart_value', cart_value)
  //console.log('total_predictive_value', total_predictive_value)

  // Récupérer les steps
  const step_elems = document.querySelectorAll('#mmProgressBarProduct .mm-dc-pb-step-elem');
  const step_values = Array.from(step_elems).map(s => parseInt(s.dataset.price)).sort((a, b) => a - b);
  const step_count = step_values.length;

  // Compter le nombre de steps atteints
  let reached_steps = 0;
  step_values.forEach(v => {
    if (total_predictive_value >= v) reached_steps++;
  });

  // Définir la largeur en fonction du nombre de steps
  let percent = 0;
  if (step_count > 0) {
    if (reached_steps >= step_count) {
      percent = 100;
    } else {
      // La logique : la barre se situe entre 0 et step_count + 1 positions (avec 100% à la fin)
      percent = ((reached_steps + 1) / (step_count + 1)) * 100;
    }
  } else {
    percent = 100; // Si aucun step
  }

  preview_bar.style.width = percent + '%';

  // Met à jour les steps visuellement
  step_elems.forEach(step => {
    const step_value = parseInt(step.dataset.price);
    if (step.classList.contains('mm-dc-pb-step-elem-activated')) return;
    if (total_predictive_value >= step_value) {
      step.classList.add('mm-dc-pb-step-elem-preview-activated');
    } else {
      step.classList.remove('mm-dc-pb-step-elem-preview-activated');
    }
  });

  // Masquer/afficher .mm-pb-discount-available
  const accessory_checkboxes = document.querySelectorAll('.mm-accessory-card input[type="checkbox"]');
  const atLeastOneChecked = Array.from(accessory_checkboxes).some(cb => cb.checked);

  const steps_with_discount = document.querySelectorAll('#mmProgressBarProduct .mm-dc-pb-step-elem .mm-pb-discount-available');
  steps_with_discount.forEach(discountElem => {
    discountElem.style.display = atLeastOneChecked ? 'none' : '';
  });
}

function checkThisCard(checkbox) {
  const card = checkbox.closest('.mm-accessory-card');
  card.classList.toggle('mm-active', checkbox.checked);

  updateCTAButtonPrice();
  updateProgressBarPreview(); 
  updateCardPrices();
}

function updateCardPrices() {
  // Ne rien faire si un accessoire est déjà dans le panier
  if (document.querySelector('data-accessory-in-cart')) return;

  const cards = document.querySelectorAll('.mm-accessory-card-wrapper');
  const checkedCards = Array.from(cards).filter(card => card.querySelector('input[type="checkbox"]').checked);

  const product_value = parseInt(document.querySelector('#mmDataPriceElem')?.dataset.value || 0);
  const cart_value = parseInt(document.querySelector('.mm-dc-cta')?.dataset.totalPrice || 0);
  const total_predictive_value = product_value + cart_value;

  //console.log('total_predictive_value ::', total_predictive_value)

  if (total_predictive_value >= 3000) {
    //console.log('on affiche les prix réduits');
    if (checkedCards.length === 0) {
      // Aucune carte cochée : afficher tous les prix réduits UNIQUEMENT pour les accessoires
      cards.forEach(card => {
        const reducedAll = card.querySelectorAll('[data-reduced]');
        const originalAll = card.querySelectorAll('[data-original]');
        const isAccessory = card.dataset.type === 'Accessoires';
        //console.log('isAccessory', isAccessory)

        if (isAccessory) {
          if (reducedAll) {
            reducedAll.forEach(function(reduced) {
              reduced.style.display = 'block';
            })
          }
          if (originalAll) {
            originalAll.forEach(function(original) {
              original.style.display = 'none';
            })
          }
        } else {
          // Pas un accessoire → on garde le prix normal
          if (reducedAll) {
            reducedAll.forEach(function(reduced) {
              reduced.style.display = 'none';
            })
          }
          if (originalAll) {
            originalAll.forEach(function(original) {
              original.style.display = 'block';
            })
          }
        }
      });
    } else {
      // Une ou plusieurs cartes cochées
      cards.forEach(card => {
        const checkbox = card.querySelector('input[type="checkbox"]');
        const reducedAll = card.querySelectorAll('[data-reduced]');
        const originalAll = card.querySelectorAll('[data-original]');
        const isAccessory = card.dataset.type === 'Accessoires';

        if (!checkbox.checked) {
          // Non cochée → prix normal
          if (reducedAll) {
            reducedAll.forEach(function(reduced) {
              reduced.style.display = 'none';
            })
          }
          if (originalAll) {
            originalAll.forEach(function(original) {
              original.style.display = 'block';
            })
          }
          checkbox.dataset.displayedPrice = checkbox.dataset.price;
        } else {
          if (card === checkedCards[0] && isAccessory) {
            // Première carte cochée ET c’est un accessoire → prix réduit
            if (reducedAll) {
              reducedAll.forEach(function(reduced) {
                reduced.style.display = 'block';
              })
            }
            if (originalAll) {
              originalAll.forEach(function(original) {
                original.style.display = 'none';
              })
            }
            checkbox.dataset.displayedPrice = checkbox.dataset.priceReduced;
          } else {
            // Sinon prix normal (ou si ce n’est pas un accessoire)
            if (reducedAll) {
              reducedAll.forEach(function(reduced) {
                reduced.style.display = 'none';
              })
            }
            if (originalAll) {
              originalAll.forEach(function(original) {
                original.style.display = 'block';
              })
            }
            checkbox.dataset.displayedPrice = checkbox.dataset.price;
          }
        }
      });
    }
  } else {
    //console.log('on n\'affiche pas les prix réduits');
    // on n'affiche pas les prix réduits
    cards.forEach(card => {
      const reducedAll = card.querySelectorAll('[data-reduced]');
      const originalAll = card.querySelectorAll('[data-original]');
      if (reducedAll) {
        reducedAll.forEach(function(reduced) {
          reduced.style.display = 'none';
        })
      }
      if (originalAll) {
        originalAll.forEach(function(original) {
          original.style.display = 'block';
        })
      }
    });
  }
}


// Appeler au load de la page
window.addEventListener('DOMContentLoaded', updateProgressBarPreview);





